import React from 'react';

/*
 * Isolates a plugin's render failures so one broken plugin cannot take down the
 * host. Wraps every plugin route render (see WrappedRoute). Part of the plugin
 * contract, not an add-on.
 */
class PluginErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	// not called directly; special React lifecycle method that React calls automatically when a descendant throws during rendering.
	static getDerivedStateFromError(error) {

		// logging error is not needed generally, but react does pass it to this method
		// console.error('[PluginErrorBoundary] error', error);

		/* EXAMPLE 
			If you want to handle specific error types differently, you can check the error type here and return different state or messages accordingly. 
			For instance, if you trhow a custom error type called `AuthenticationError`, you could do something like this: 

		if (error instanceof AuthenticationError) {
			return {
				hasError: true,
				message: 'Please sign in again.',
				errorCode: error.code,
			};
		}

		*/


		// DEFAULT - Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	// a React lifecycle method used to handle errors in child components and prevent the entire app from crashing. 
	// It also allows side-effects like logging errors during the commit phase.
	componentDidCatch(error, info) {
		console.error('[PluginErrorBoundary] plugin render failed:', error, info);
	}

	render() {
		if (this.state.hasError) {
			return (
				<div style={{ padding: 24 }}>
					This section failed to load. Try reloading the page.
				</div>
			);
		}

		return this.props.children;
	}
}


export default PluginErrorBoundary;
